import React from "react";
import { Plus } from "lucide-react";

interface AdminTabsProps {
  activeTab: "memes" | "stickers" | "templates" | "users";
  memesCount: number;
  stickersCount: number;
  templatesCount: number;
  usersCount: number;
  onTabChange: (tab: "memes" | "stickers" | "templates" | "users") => void;
  onAddSticker: () => void;
  onAddTemplate: () => void;
}

const AdminTabs: React.FC<AdminTabsProps> = ({
  activeTab,
  memesCount,
  stickersCount,
  templatesCount,
  usersCount,
  onTabChange,
  onAddSticker,
  onAddTemplate,
}) => {
  return (
    <div className="bg-white/70 backdrop-blur-sm rounded-2xl sm:rounded-3xl p-6 shadow-xl border border-pink-100 mb-8">
      <div className="flex justify-center space-x-4 mb-6">
        <button
          onClick={() => onTabChange("memes")}
          className={`px-6 py-3 rounded-lg font-semibold transition-colors ${
            activeTab === "memes"
              ? "bg-pink-500 text-white"
              : "bg-white/50 text-gray-700 hover:bg-white/70"
          }`}
          dir="rtl"
        >
          מימז ({memesCount})
        </button>
        <button
          onClick={() => onTabChange("stickers")}
          className={`px-6 py-3 rounded-lg font-semibold transition-colors ${
            activeTab === "stickers"
              ? "bg-pink-500 text-white"
              : "bg-white/50 text-gray-700 hover:bg-white/70"
          }`}
          dir="rtl"
        >
          סטיקרים ({stickersCount})
        </button>
        <button
          onClick={() => onTabChange("templates")}
          className={`px-6 py-3 rounded-lg font-semibold transition-colors ${
            activeTab === "templates"
              ? "bg-pink-500 text-white"
              : "bg-white/50 text-gray-700 hover:bg-white/70"
          }`}
          dir="rtl"
        >
          תבניות ({templatesCount})
        </button>
        <button
          onClick={() => onTabChange("users")}
          className={`px-6 py-3 rounded-lg font-semibold transition-colors ${
            activeTab === "users"
              ? "bg-pink-500 text-white"
              : "bg-white/50 text-gray-700 hover:bg-white/70"
          }`}
          dir="rtl"
        >
          משתמשים ({usersCount})
        </button>
      </div>

      {activeTab === "stickers" && (
        <div className="flex justify-center mb-6">
          <button
            onClick={onAddSticker}
            className="px-6 py-3 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors flex items-center space-x-2"
            dir="rtl"
          >
            <Plus className="h-4 w-4" />
            <span>הוסף סטיקר</span>
          </button>
        </div>
      )}

      {activeTab === "templates" && (
        <div className="flex justify-center mb-6">
          <button
            onClick={onAddTemplate}
            className="px-6 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors flex items-center space-x-2"
            dir="rtl"
          >
            <Plus className="h-4 w-4" />
            <span>הוסף תבנית</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default AdminTabs;
